import type { InputSource } from 'modules/forms/types';

/** How an answer was produced, so analysis can tell dictated feedback from typed. */
export const nextInputSource = (
  prev: InputSource | undefined,
  change: 'typed' | 'dictated',
  hadText: boolean
): InputSource => {
  if (!prev || !hadText) return change;
  return prev === change ? prev : 'mixed';
};
